import React from "react";

export default function SQL_Selects_Distinct() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_SELECT_DISTINCT</h1>
      <p>
        This is the SQL_SELECT_DISTINCT component generated from the SQL JSON.
      </p>
    </div>
  );
}
